import http from 'helpers/http';
import { DataNotification } from '.';

function useFetchNotification() {
  const fetchNotification = async ({
    page, pageSize, is_read, ln,
  }: Readonly<{ page: string; pageSize: string; is_read?: boolean; ln?: string }>) => {
    let constructUrl = `${process.env.REACT_APP_API_V2}notification?page=${page}&page_size=${pageSize}&language=en`;
    if (is_read) constructUrl += '&is_read=true';
    else constructUrl += '&is_read=false';
    try {
      const response = await http.get(constructUrl);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const hideNotification = async ({ notificationId }) => {
    try {
      const response = await http.patch(`${process.env.REACT_APP_API_V2}notification/${notificationId}/hide`);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const readNotification = async ({ notificationId }) => {
    try {
      const response = await http.patch(`${process.env.REACT_APP_API_V2}notification/${notificationId}/read`);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const removeNotificationById = (notificationsArray: DataNotification, idToRemove: string) => notificationsArray.filter((notification) => notification.notification_id !== idToRemove);
  return {
    fetchNotification,
    hideNotification,
    readNotification,
    removeNotificationById,
  };
}

export default useFetchNotification;
